
















































import Vue from 'vue'

export default Vue.extend(
  {
    name: 'AlpineMessageDialog',
   props: {
     confirmText: {
       type: String,
       default: 'Confirm',
       required: false
     },
     cancelText: {
       type: String,
       default: 'Cancel',
       required: false
     },
     width: {
       type: Number,
       default: 550
     },
     scrollOverflow: {
       type: Boolean,
       default: false
     }
   },
    data()
    {
      return {
        dialog: false,
        isConfirm: false,
        message: '',
        title: '',
        defaultTitle: 'Spirion',
        onCallerAccept: null,
        onCallerCancel: null,
        busy: false
      }
    },
    methods:
    {
      showMessage(message: string, title: string = null): void
      {
        this.message = message;
        this.setTitle(title);
        this.onCallerAccept = null;
        this.dialog = true;
      },
      showConfirm(message: string, onAccept: Function, title: string = null, onCancel: Function): void
      {
        this.isConfirm = true;
        this.message = message;
        this.setTitle(title);
        this.onCallerAccept = onAccept;
        this.onCallerCancel = onCancel;
        this.dialog = true;
      },
      closeDialog(): void
      {
        this.isConfirm = false;
        this.dialog = false;
      },
      setTitle(title: string): void
      {
        this.title = title !== null && title !== undefined && title.length ? title : this.defaultTitle;
      },
      async onAcceptInternal()
      {
        if (this.onCallerAccept) {
          try {
            this.busy = true;
            await this.onCallerAccept();
          }
          finally {
            this.busy = false;
            this.closeDialog();
          }
        }
        else {
          this.closeDialog();
        }
        this.resetHandlers();
      },
      onCancelInternal(): void {
        this.closeDialog();
        if (this.onCallerCancel) {
          this.onCallerCancel();
        }
        this.resetHandlers();
      },
      resetHandlers() {
        this.onCallerAccept = null;
        this.onCallerCancel = null;
      }
    }
  }
);
